import makeItemsReducer from './items'
import { isUndefined, without, isNull } from 'lodash'
import {
  GET_WANTED_ITEMS,
  I_WANT_NOT_SUCCESS,
  I_WANT_SUCCESS,
} from '../actions'

const removeWhenNotOwnedAnymore = (prevState, { type, payload }) => {
  // When no data in list don't care
  if (prevState && isNull(prevState.ids)) {
    return prevState
  }

  switch (type) {
    // Fukin mad not remove data from store instead remove only
    // if stupid monkey re-click i want this re-append item on top
    case I_WANT_NOT_SUCCESS: {
      if (isUndefined(prevState.data[payload])) {
        return prevState
      }
      return {
        ...prevState,
        ids: without(prevState.ids, payload),
      }
    }
    case I_WANT_SUCCESS: {
      if (isUndefined(prevState.data[payload])) {
        // User want sum stuff invalidate cache!
        return {
          ...prevState,
          ids: null,
          data: {},
          pagination: {
            total: null,
            nextOffset: 0,
          },
          cache: {
            key: null,
          },
        }
      } else {
        // User want sum stuff in local data simply append on top
        return {
          ...prevState,
          ids: [payload].concat(prevState.ids),
        }
      }
    }
    default:
      return prevState
  }
}

export default makeItemsReducer(GET_WANTED_ITEMS, {
  handleWanted: false,
  extendReducers: [removeWhenNotOwnedAnymore],
})



// WEBPACK FOOTER //
// ./src/reducers/wantedItems.js